export interface DataItem {
  date: string
  value: number
}

export type MetricType =
  | 'visitors'
  | 'pageviews'
  | 'revenue'
  | 'orders'
  | 'aov'
  | 'AddToCart'
  | 'Purchase'
  | 'InitiateCheckout'

export interface CoreMetrics {
  visitors: number
  pageviews: number
  datasets: {
    visitors: DataItem[]
    pageviews: DataItem[]
  }
}

export type BreakdownType = 'source' | 'page' | 'country' | 'device'

export enum BreakdownEnum {
  source = '$referrer',
  page = 'current_hash',
  country = '$geoip_country_name',
  device = '$device_type',
}

export type DateFrom = 7 | 14 | 30
